import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, Input, OnInit, Optional, Type } from "@angular/core";
import { WidgetPlanEditMessageComponent } from "@root/router/component/automation/edit/message/message.component";
import { WidgetPlanEditPriceComponent } from "@root/router/component/automation/edit/price/price.component";
import { WidgetPlanEditReviewComponent } from "@root/router/component/automation/edit/review/review.component";
import { WidgetPlanEditTaskComponent } from "@root/router/component/automation/edit/task/task.component";
import { NzModalService } from "ng-zorro-antd/modal";
import { WidgetPlanEditDepositComponent } from "../../automation/edit/deposit/deposit.component";
import { MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { NzDrawerRef } from "ng-zorro-antd/drawer";

@Component({
  selector: "host-house-order-automation",
  templateUrl: "./house-order-automation.component.html",
  styleUrls: ["./house-order-automation.component.scss"],
})
export class HouseOrderAutomationComponent implements OnInit {
  _code;
  @Input()
  get code() {
    return this._code;
  }
  set code(value) {
    this._code = value;

    this.pageInit = false;
    this.initPlanList();
  }
  @Input() pageType: "sidebar" | "modal" = "sidebar";
  private readonly PlanListApi = "/api/reservation/plan_list";
  pageInit = false;
  page = 1;
  pageSize = 50;
  total = 0;
  listOfPlan = [];
  constructor(
    private http: HttpClient,
    private calendarSrv: MultiHouseCalendarService,
    private modal: NzModalService,
    private cdr: ChangeDetectorRef,
    @Optional() private drawerRef: NzDrawerRef,
  ) {}

  ngOnInit() {
    // this.initPlanList();
  }

  private initPlanList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
      reservation_code: this.code,
    };
    this.http.get(this.PlanListApi, { params }).subscribe((rst: any) => {
      this.pageInit = true;
      this.listOfPlan = rst?.data?.list;
      this.total = rst?.data?.count;

      /**
       * @todo
       * @compact
       */
      this.cdr.markForCheck();
    });
  }

  private getWidgetEditCmp(type): Type<any> {
    const map = {
      message: WidgetPlanEditMessageComponent,
      comment: WidgetPlanEditReviewComponent,
      price: WidgetPlanEditPriceComponent,
      task: WidgetPlanEditTaskComponent,
      deposit: WidgetPlanEditDepositComponent,
    };
    return map[type];
  }

  private displayEditModal(title, id, type) {
    const cmp = this.getWidgetEditCmp(type);
    const modal = this.modal.create({
      nzTitle: title,
      nzContent: cmp,
      nzWidth: 500,
      nzFooter: null,
      nzComponentParams: {
        id,
      },
      nzData: {
        id,
      },
      // nzFooter: null
    });
    modal.afterClose.subscribe(() => {
      this.initPlanList();
    });
  }

  onPageChange(page) {
    this.initPlanList();
  }

  onClickItem(data) {
    this.displayEditModal(data.plan_name, data.plan_id, data.type);
  }

  onClose() {
    this.calendarSrv.cancelSelectReservation();
    this.drawerRef?.close();
  }
}
